import { apiFetch } from "../../lib/api";
import type { Order, OrderStatus } from "./orders.types";

export async function getOrders(): Promise<Order[]> {
  const response = await apiFetch("/orders");
  if (!response.ok) throw new Error("Impossible de charger les commandes.");
  return response.json();
}

export async function updateOrderStatus(id: string, status: OrderStatus): Promise<Order> {
  const response = await apiFetch(`/orders/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
  if (!response.ok) throw new Error("Impossible de mettre à jour la commande.");
  return response.json();
}